import React from 'react';
import { useSelector } from 'react-redux';

import Map from '../components/Map';

const MapContainer = () => {
  const { origin, destinations, routes, travelMode, timeZone } = useSelector((state) => state.map.data);

  return <Map origin={origin} destinations={destinations} timeZone={timeZone} routes={routes[travelMode] || []} />;
};

export default MapContainer;
